export enum AnalyticsEventType {
  QUOTE_OR_BIND = 'QUOTE OR BIND',
  QUICK_QUOTE_START = 'QUICK QUOTE START',
  QUICK_QUOTE_COMPLETE = 'QUICK QUOTE COMPLETE',
  QUICK_QUOTE_AGENT_HELP = 'QUICK QUOTE AGENT HELP',
  QUICK_QUOTE_AGENT_SENT_TO_AGENT = 'QUICK QUOTE SEND TO AGENT',
  QUICK_QUOTE_AGENT_NOTIFIED = 'QUICK QUOTE AGENT NOTIFIED',
  BUTTON_QUICK_QUOTE_NEXT = 'BUTTON QUICK QUOTE NEXT',
  BUTTON_COMPLETE_GET_ANOTHER_QUOTE = 'BUTTON COMPLETE GET ANOTHER QUOTE',
  BUTTON_COMPLETE_SEND_TO_AGENT = 'BUTTON COMPLETE SEND TO AGENT',
  BUTTON_AGENT_HELP_SEND_TO_AGENT = 'BUTTON AGENT HELP SEND TO AGENT',
  BUTTON_AGENT_NOTIFIED_GET_ANOTHER_QUOTE = 'BUTTON AGENT NOTIFIED GET ANOTHER QUOTE',

  REPLACE_VEHICLE_VIN_YEAR = 'REPLACE_VEHICLE_VIN_YEAR',
  REPLACE_VEHICLE_UW_QUESTIONS = 'REPLACE_VEHICLE_UW_QUESTIONS',
  REPLACE_VEHICLE_SEND_TO_AGENT = 'REPLACE_VEHICLE_SEND_TO_AGENT',
  REPLACE_VEHICLE_BIND_COMPLETE = 'REPLACE_VEHICLE_BIND_COMPLETE',
  REPLACE_VEHICLE_SEND_TO_AGENT_CONFIRMATION = 'REPLACE_VEHICLE_SEND_TO_AGENT_CONFIRMATION',
  REPLACE_VEHICLE_HARD_STOP = 'REPLACE_VEHICLE_HARD_STOP',
  REPLACE_VEHICLE_HARD_STOP_SEND_TO_AGENT = 'REPLACE_VEHICLE_HARD_STOP_SEND_TO_AGENT',
  REPLACE_VEHICLE_HARD_STOP_OTHER_SEND_TO_AGENT = 'REPLACE_VEHICLE_HARD_STOP_OTHER_SEND_TO_AGENT',
  REPLACE_VEHICLE_HARD_STOP_OTHER_SEND_TO_AGENT_SUCCESS = 'REPLACE_VEHICLE_HARD_STOP_OTHER_SEND_TO_AGENT_SUCCESS',

  REPLACE_VEHICLE_QUOTE_OR_BIND_FIND_VIN = 'REPLACE_VEHICLE_QUOTE_OR_BIND_FIND_VIN',
  REPLACE_VEHICLE_QUOTE_OR_BIND_SEND_TO_AGENT = 'REPLACE_VEHICLE_QUOTE_OR_BIND_SEND_TO_AGENT',
  BUTTON_REPLACE_VEHICLE_VIN_START_FIND_VIN = 'BUTTON_REPLACE_VEHICLE_VIN_START_FIND_VIN',
  REPLACE_VEHICLE_FIND_VIN = 'REPLACE_VEHICLE_FIND_VIN',
  REPLACE_VEHICLE_QUOTE_SPINNER = 'REPLACE_VEHICLE_QUOTE_SPINNER',
  REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT = 'REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT',
  REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT_CANCEL = 'REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT_CANCEL',
  REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT_SENT_TO_AGENT = 'REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT_SENT_TO_AGENT',
  REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT_CANCEL_SEND_TO_AGENT = 'REPLACE_VEHICLE_QUOTE_SPINNER_NEED_AGENT_CANCEL_SEND_TO_AGENT',
  REPLACE_VEHICLE_TPI_DETAILS = 'REPLACE_VEHICLE_TPI_DETAILS',
  REPLACE_VEHICLE_TPI_DETAILS_CANCEL = 'REPLACE_VEHICLE_TPI_DETAILS_CANCEL',
  REPLACE_VEHICLE_AGENT_HELP = 'REPLACE_VEHICLE_AGENT_HELP',
  REPLACE_VEHICLE_AGENT_HELP_SEND_TO_AGENT = 'REPLACE_VEHICLE_AGENT_HELP_SEND_TO_AGENT',
  REPLACE_VEHICLE_UW_DETAILS_CANCEL = 'REPLACE_VEHICLE_UW_DETAILS_CANCEL',
  REPLACE_VEHICLE_UW_CANCEL_SEND_TO_AGENT = 'REPLACE_VEHICLE_UW_CANCEL_SEND_TO_AGENT',
  REPLACE_VEHICLE_TPI_CANCEL_SEND_TO_AGENT = 'REPLACE_VEHICLE_TPI_CANCEL_SEND_TO_AGENT',

  REPLACE_VEHICLE_NEW_PREMIUM = 'REPLACE_VEHICLE_NEW_PREMIUM',
  REPLACE_VEHICLE_NEW_PREMIUM_CANCEL = 'REPLACE_VEHICLE_NEW_PREMIUM_CANCEL',
  REPLACE_VEHICLE_NEW_PREMIUM_SEND_TO_AGENT = 'REPLACE_VEHICLE_NEW_PREMIUM_SEND_TO_AGENT',
  REPLACE_VEHICLE_NEW_PREMIUM_CANCEL_SEND_TO_AGENT = 'REPLACE_VEHICLE_NEW_PREMIUM_CANCEL_SEND_TO_AGENT',
  REPLACE_VEHICLE_FUTURE_PAYMENTS = 'REPLACE_VEHICLE_FUTURE_PAYMENTS',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_CANCEL = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_CANCEL',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_SEND_TO_AGENT = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_SEND_TO_AGENT',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_CANCEL_SEND_TO_AGENT = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_CANCEL_SEND_TO_AGENT',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT_SENT_TO_AGENT = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT_SENT_TO_AGENT',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT_CANCEL = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT_CANCEL',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT_CANCEL_SENT_TO_AGENT = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_NEED_AGENT_CANCEL_SENT_TO_AGENT',
  REPLACE_VEHICLE_ONLINE_BIND_ERROR = 'REPLACE_VEHICLE_ONLINE_BIND_ERROR',
  REPLACE_VEHICLE_ONLINE_BIND_ERROR_SEND_TO_AGENT = 'REPLACE_VEHICLE_ONLINE_BIND_ERROR_SEND_TO_AGENT'
}

export enum ReplaceVehicleQuickQuoteContext {
  REPLACE_VEHICLE = 'REPLACE_VEHICLE',
  QUICK_QUOTE = 'QUICK_QUOTE'
}

export enum ReplaceVehicleQuickQuoteOperation {
  REPLACE_VEHICLE_BIND = 'REPLACE_VEHICLE_BIND',
  REPLACE_VEHICLE_SEND_AGENT = 'REPLACE_VEHICLE_SEND_AGENT',
  REPLACE_VEHICLE_ERROR_SEND_AGENT = 'REPLACE_VEHICLE_ERROR_SEND_AGENT',
  QUICK_QUOTE_SEND_AGENT = 'QUICK_QUOTE_SEND_AGENT',
  REPLACE_VEHICLE_SEND_TO_AGENT_BIND = 'REPLACE_VEHICLE_SEND_TO_AGENT_BIND',
  REPLACE_VEHICLE_TPI_SEND_TO_AGENT = 'REPLACE_VEHICLE_TPI_SEND_TO_AGENT',
  REPLACE_VEHICLE_UW_SEND_TO_AGENT = 'REPLACE_VEHICLE_UW_SEND_TO_AGENT',
  REPLACE_VEHICLE_COMPARE_QUOTE_SEND_TO_AGENT = 'REPLACE_VEHICLE_COMPARE_QUOTE_SEND_TO_AGENT',
  REPLACE_VEHICLE_FUTURE_PAYMENTS_SEND_TO_AGENT = 'REPLACE_VEHICLE_FUTURE_PAYMENTS_SEND_TO_AGENT',
  REPLACE_VEHICLE_HARDSTOP_OTHER_SEND_TO_AGENT = 'REPLACE_VEHICLE_HARDSTOP_OTHER_SEND_TO_AGENT'
}

export enum ReplaceVehiclePaymentsFrequency {
  MONTHLY_PAY = 'Monthly Pay',
  FULL_PAY = 'Full Pay'
}

export enum ReplaceVehicleApiOperation {
  QUICK_QUOTE = 'quickquotes',
  REPLACE_VEHICLE = 'quotes'
}
